// extracted by mini-css-extract-plugin
export var fadeOut = "BodyText-module--fadeOut--f3592";
export var fadePop = "BodyText-module--fade-pop--4da31";
export var growHeightIn = "BodyText-module--grow-height-in--f6ac9";